/* @flow */

import label from './label';

const labelAtivo = (ativo: 0 | 1) => label(ativo ? 'Sim' : 'Não', ativo ? 'success' : 'danger');

export default labelAtivo;
